/**
 * Parses a raw address string into strasse and hausnummer components.
 * Matches a trailing house number (digits with optional letter/range suffix).
 * Examples: "Musterstraße 5a" → { strasse: "Musterstraße", hausnummer: "5a" }
 *           "Am Markt 3-7" → { strasse: "Am Markt", hausnummer: "3-7" }
 */
export function parseAddress(address: string): { strasse: string; hausnummer: string } {
  const trimmed = address.trim();
  const match = trimmed.match(/^(.+?)\s+(\d+[\w\-/]*)\s*$/);
  if (match) {
    return { strasse: match[1].trim(), hausnummer: match[2].trim() };
  }
  return { strasse: trimmed, hausnummer: '' };
}
